export const LOCAL_API_URL = 'http://127.0.0.1:8000'
export const PRODUCTION_API_URL = 'https://aipoliteia.eu'

export const ACTIVE_URL = PRODUCTION_API_URL